import React from 'react';
import { componentService } from 'js/services/component.service';

export const ResponsibleGamingHistory = React.lazy(() => import(/* webpackChunkName: "responsible-gaming-history" */ './ResponsibleGamingHistory'));

// <hub2-responsible-gaming-history> </hub2-responsible-gaming-history>
componentService.registerWebContentComponents({ ResponsibleGamingHistory });
